import { useTranslation } from 'react-i18next';

import {
  meetsPasswordMinLengthRequirement,
  meetsPasswordMixedCasingRequirement,
  meetsPasswordNonAlphaRequirement,
} from '~/utils/passwords';

import { PasswordRequirementHint } from './PasswordRequirementHint';

type Props = {
  password: string;
  showInvalid: boolean;
};

export const PasswordRequirements = ({ password, showInvalid }: Props) => {
  const { t } = useTranslation(['auth']);

  return (
    <>
      <PasswordRequirementHint showInvalid={showInvalid} valid={meetsPasswordMinLengthRequirement(password)}>
        {t('auth:registrationPage.stepAccountInformation.form.passwordField.requirements.minLength')}
      </PasswordRequirementHint>
      <PasswordRequirementHint showInvalid={showInvalid} valid={meetsPasswordMixedCasingRequirement(password)}>
        {t('auth:registrationPage.stepAccountInformation.form.passwordField.requirements.mixedCasing')}
      </PasswordRequirementHint>
      <PasswordRequirementHint showInvalid={showInvalid} valid={meetsPasswordNonAlphaRequirement(password)}>
        {t('auth:registrationPage.stepAccountInformation.form.passwordField.requirements.nonAlpha')}
      </PasswordRequirementHint>
    </>
  );
};
